



































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Util, getExcelJSONDataByList, getPageAPIs} from '@/common/util';
import {DeepLoop} from '@/common/deepLoop/deepLoop';
import {OrderVerifyBillAPI} from '@/common/api/financeManage/orderVerifyBill';

import {
  getCommonList
} from '@/common/config'

import dayjs from '@/plugins/dayjs';

export const pageApiList = getPageAPIs(OrderVerifyBillAPI);

function getCurrentMonthDate() {
  const currentDay = (dayjs() as any).format('YYYY-MM-DD');

  const curMonthStartDay = (dayjs().startOf('month') as any).format(
      'YYYY-MM-DD'
  );

  return [curMonthStartDay, currentDay];
}

const defaultForm = {
  order_no: '', // 订单号/退款订单号

  bill_status: '', // 对账状态:0未对账 1处理成功 2处理失败 3金额对账失败 不传为所有

  time: getCurrentMonthDate(), // 时间
};

// 对账状态:0未对账 1处理成功 2处理失败 3金额对账失败  4状态对账失败
const allBizType2ch: string[] = [
  '未对账',
  '处理成功',
  '处理失败',
  '金额对账失败',
  '状态对账失败'
];

// 订单类型:1单店卡 2全国会员 3购买优惠券 4开台订单 5棋牌订单 6售卖柜 7收银台订单 8收银台商品 9用户端助教 10比赛 11球杆柜租赁 12熊猫币
const allOrderType2ch: string[] = [
  '',
  '单店卡',
  '全国会员',
  '购买优惠券',
  '开台订单',
  '棋牌订单',
  '售卖柜',
  '收银台订单',
  '收银台商品',
  '用户端助教',
  '比赛',
  '球杆柜租赁',
  '熊猫币',
];

// 是否退款:1是 0否
const allRefundType2ch: string[] = [
  '否',
  '是',
];


// 原订单支付状态:0未知 1处理成功 2处理失败
const originpayStatus2Ch: string[] = ['未知', '已处理']

// 通联订单支付状态:0未知 1处理成功 2处理失败
const allinpayStatus2Ch: string[] = ['未知', '处理成功', '处理失败']

@Component({
  filters: {
    showOrderTypeName: function(type: number) {
      return allOrderType2ch[type] || ''
    },
    showRefundTypeName: function(type: number) {
      return allRefundType2ch[type] || ''
    },
    showBizTypeName(type: number) {
      return allBizType2ch[type] || '未知';
    },

    showOriginpayStatusName(order_status: number) {
      return originpayStatus2Ch[order_status] || ''
    },

    showAllinpayStatusName(is_status: number) {
      return allinpayStatus2Ch[is_status] || ''
    }
  },
  components: {

  },
})
export default class MerchantWithdrawList extends Vue {
  private abnormalPayOrderListApi: any;

  private deepLoopUtil: any;

  private utilIns: any;

  private abnormalOrderStatusList: any[] = [
    getCommonList(allBizType2ch, 1)
  ];

  constructor() {
    super();
    this.abnormalPayOrderListApi = new OrderVerifyBillAPI();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };

    // this.forms = {
    //   ...this.deepLoopUtil.deepCopy(defaultForms),
    // }

    this.utilIns = new Util();
  }

  private form: any;

  private forms: any;

  private firstLoading: boolean = true;

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private activated(): void {
    this.getTable();
  }

  private getTable(): void {
    this.abnormalPayOrderListApi.getList(
        this.getAbnormalPayOrderListParams(),
        (res: any) => {
          console.log(res, 'res');
          // this.tableData = res.data;
          const {data} = res;

          const {list, count, page, prepage} = data || {};

          const newTableList = Array.isArray(list)
              ? list.map(this.handleTableData)
              : [];

          this.$set(this.tablePage, 'totalCount', count);
          this.$set(this.tablePage, 'pageNo', page);
          this.$set(this.tablePage, 'pageSize', prepage);

          this.tableData = newTableList;

          this.firstLoading = false;
        },
        () => {
          this.firstLoading = false;
        },
        false
    );
  }

  private getAbnormalPayOrderListParams(mode = 'all') {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {order_no, bill_status, time} = form || {};

    const {pageNo, pageSize} = tablePage || {};

    const outerParams: any = {};
    if (order_no) {
      outerParams.order_no = order_no;
    }

    if (typeof bill_status == 'number') {
      outerParams.bill_status = bill_status;
    }

    if (Array.isArray(time) && time.length === 2) {
      const [startDate, endDate] = time;

      outerParams.start_date = startDate;

      outerParams.end_date = endDate;
    }

    if (
        mode == 'exportExcel' &&
        !(outerParams.start_date && outerParams.end_date)
    ) {
      this.$message.error('请选择日期导出数据');
      return null;
    }

    if (mode === 'all') {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      // outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, 'outerParams');

    return outerParams;
  }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    // const { gender } = data;
    const newData = {
      ...data,
    };

    return newData;
  }

  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getTable();
  }

  private tableData: any[] = [];

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }
}
